module.exports = __webpack_public_path__ + "static/student-872811a7de350ec304f73aa85a57b589.webm";